/**
 * RoutePage.jsx
 * Pagina de Cadastro/Edicao de Rota com Wizard Premium
 *
 * Rotas (padrao Traccar):
 *   /settings/route      -> Criar nova
 *   /settings/route/:id  -> Editar existente
 *
 */

import React, { useState, useEffect } from 'react';
import {
 Box, Typography, CircularProgress, Button 
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { usePremiumTokens } from '../common/theme/usePremiumTokens';
import { useTranslation } from '../common/components/LocalizationProvider';
import RouteFormWizard from './components/RouteFormWizard';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from './components/SettingsMenu';

const RoutePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const t = useTranslation();
  const tokens = usePremiumTokens();

  const [route, setRoute] = useState(null);
  const [loading, setLoading] = useState(!!id);
  const [error, setError] = useState(null);

  const colors = {
    accent: tokens?.accent?.primary || '#00d4aa',
    error: tokens?.semantic?.error || '#f85149',
    textSecondary: tokens?.text?.secondary || '#8b949e',
  };

  useEffect(() => {
    if (id) {
      setLoading(true);
      fetch(`/api/routes/${id}`)
        .then((res) => {
          if (!res.ok) throw new Error(t('wizardErrorNotFound') || 'Rota nao encontrada');
          return res.json();
        })
        .then((data) => {
          setRoute(data);
          setLoading(false);
        })
        .catch((err) => {
          setError(err.message);
          setLoading(false);
        });
    }
  }, [id, t]);

  if (loading) {
    return (
      <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedRoutes']}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <CircularProgress sx={{ color: colors.accent }} />
        </Box>
      </PageLayout>
    );
  }

  if (error) {
    return (
      <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedRoutes']}>
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography sx={{ color: colors.error, mb: 2 }}>{error}</Typography>
          <Button
            variant="outlined"
            onClick={() => navigate('/settings/routes')}
            sx={{ color: colors.textSecondary, borderColor: colors.textSecondary }}
          >
            {t('sharedBack') || 'Voltar'}
          </Button>
        </Box>
      </PageLayout>
    );
  }

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedRoutes']}>
      <Box sx={{ p: { xs: 1, sm: 2 } }}>
        <RouteFormWizard
          key={id || 'new'}
          route={route}
          onSave={() => navigate('/settings/routes')}
          onCancel={() => navigate('/settings/routes')}
        />
      </Box>
    </PageLayout>
  );
};

export default RoutePage;
